import { CONTENT_PLATFORM_PROPERTY_NAME, getContentPropertyValue } from 'content-management-data-lib';
import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { getEarlyRequesterResultPromise } from '../utils/getEarlyRequesterResultPromise';
import { useMemo } from 'react';
const ContentGroupsQuery = registerQuery({
  fieldName: 'fetchContentGroups',
  args: ['contentGroupObjectType'],
  fetcher: async ({
    contentGroupObjectType
  }) => {
    const {
      results: contentGroupObjects
    } = await getEarlyRequesterResultPromise({
      name: 'fetch-content-groups',
      retryRequest: () => http.get(`content-management/search/v1/${contentGroupObjectType}`)
    });
    const contentGroupPropertyOptions = contentGroupObjects.reduce((acc, contentGroup) => {
      const translatedFromId = getContentPropertyValue(contentGroup, CONTENT_PLATFORM_PROPERTY_NAME.TRANSLATED_FROM_ID);
      if (!translatedFromId) {
        acc.push({
          value: `${getContentPropertyValue(contentGroup, CONTENT_PLATFORM_PROPERTY_NAME.ID)}`,
          label: getContentPropertyValue(contentGroup, CONTENT_PLATFORM_PROPERTY_NAME.NAME),
          displayOrder: -1,
          hidden: false
        });
      }
      return acc;
    }, []);

    // Build mapping of primary object ids to their translations' object ids
    const mergedContentGroupAssociations = contentGroupObjects.reduce((acc, contentGroup) => {
      const translatedFromId = getContentPropertyValue(contentGroup, CONTENT_PLATFORM_PROPERTY_NAME.TRANSLATED_FROM_ID);
      if (translatedFromId) {
        if (acc[translatedFromId]) {
          acc[translatedFromId].push(`${contentGroup.objectId}`);
        } else {
          acc[translatedFromId] = [`${contentGroup.objectId}`];
        }
      }
      return acc;
    }, {});
    return {
      contentGroupPropertyOptions,
      mergedContentGroupAssociations,
      contentGroupObjects
    };
  }
});
const useContentGroups = contentGroupObjectType => {
  const {
    data,
    loading,
    error
  } = useQuery(ContentGroupsQuery, {
    skip: !contentGroupObjectType,
    variables: {
      contentGroupObjectType
    }
  });
  return useMemo(() => ({
    contentGroupsLoaded: contentGroupObjectType ? !loading && !!(data !== null && data !== void 0 && data.fetchContentGroups.contentGroupObjects) : true,
    contentGroupsLoadingFailed: !!error,
    contentGroupObjects: (data === null || data === void 0 ? void 0 : data.fetchContentGroups.contentGroupObjects) || [],
    contentGroupPropertyOptions: (data === null || data === void 0 ? void 0 : data.fetchContentGroups.contentGroupPropertyOptions) || [],
    mergedContentGroupAssociations: (data === null || data === void 0 ? void 0 : data.fetchContentGroups.mergedContentGroupAssociations) || {}
  }), [contentGroupObjectType, data === null || data === void 0 ? void 0 : data.fetchContentGroups.contentGroupObjects, data === null || data === void 0 ? void 0 : data.fetchContentGroups.contentGroupPropertyOptions, data === null || data === void 0 ? void 0 : data.fetchContentGroups.mergedContentGroupAssociations, error, loading]);
};
export default useContentGroups;